<template>
  <div
    class="px-8 py-8 mx-4 my-8 bg-white shadow-md place-content-center rounded-2xl"
  >
    <LoginForm />
  </div>
</template>

<script setup lang="ts">
import LoginForm from "@/components/forms/LoginForm.vue";
import { useMeta } from "vue-meta";

useMeta({ title: "เข้าสู่ระบบ" });
</script>
